<template>
  <v-dialog
    v-if="dialogItem.active"
    v-model="dialogItem.active"
    :width="$vuetify.breakpoint.mdAndUp?1000:500"
    scrollable
  >
    <v-container grid-list-md text-xs-center>
      <v-layout row wrap>
        <v-flex
          xs12
          md7
          style="z-index:5; position:relative; border-radius:4px;overflow: hidden;"
          class="pa-0 elevation-10"
          :class="[dialogItem.item.background || '',{'offset-md2 md8': !user && dialogItem.item.title == undefined && dialogItem.item.description == undefined}]"
        >
          <v-img
            contain
            :src="dialogItem.item.imageUrl"
            :lazy-src="dialogItem.item.thumbnailUrl"
            :style="{transform:`rotate(${dialogItem.item.rotate}deg)`}"
            class="slow-rotation"
            style="border-radius: 4px;max-height:95vh"
            :aspect-ratio="ratio"
            @click="!user?dialogItem.active=false:null"
          >
            <template v-slot:placeholder>
              <v-layout fill-height align-center justify-center ma-0>
                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
              </v-layout>
            </template>
          </v-img>
          <v-btn
            large
            @click="dialogItem.active=false"
            style="position:absolute;top:0px;right:0px;z-index:6;opacity:1"
            icon
            v-if="user"
          >
            <v-icon color="white" class="shadow">close</v-icon>
          </v-btn>
          <v-btn
            style="transform:scaleX(-1);position:absolute;top:0px;left:0px;z-index:6;opacity:1"
            icon
            dark
            @click="rotate()"
            large
            v-if="user"
          >
            <v-icon color="white" class="shadow">rotate_90_degrees_ccw</v-icon>
          </v-btn>
          <div
            v-if="user"
            class="ma-2"
            style="position:absolute;bottom:0px;left:0px;z-index:6;opacity:1"
          >
            <v-btn icon class="primary" @click="modifyBackground('primary')"></v-btn>
            <v-btn icon class="secondary" @click="modifyBackground('secondary')"></v-btn>
            <v-btn icon class="background-texture" @click="modifyBackground('background-texture')"></v-btn>
            <v-btn icon style="border:solid 3px white" @click="modifyBackground(' ')"></v-btn>
          </div>
        </v-flex>
        <v-flex
          xs12
          md5
          @click="!user?dialogItem.active=false:null"
          style="position:relative; z-index:4"
          class="pa-0"
          v-if="user || dialogItem.item.title || dialogItem.item.description"
        >
          <div
            style="border-radius:4px;"
            class="white px-4 pb-3 pt-0 background-texture"
            :class="{'border-radius-right mt-4':$vuetify.breakpoint.mdAndUp,'mx-3 border-radius-bottom' :$vuetify.breakpoint.smOnly, 'mx-2 border-radius-bottom' :$vuetify.breakpoint.xsOnly}"
          >
            <div v-if="user">
              <v-text-field
                placeholder="Titre"
                class="title-item pb-0 mt-0"
                v-model.trim="dialogItem.item.title"
              ></v-text-field>
              <v-textarea
                auto-grow
                rows="1"
                class="mt-0 pt-0"
                name="input-7-1"
                placeholder="Description"
                v-model.trim="dialogItem.item.description"
              ></v-textarea>

              <v-dialog
                ref="dialog"
                v-model="modal"
                :return-value.sync="dialogItem.item.date"
                lazy
                full-width
                width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    class="pt-0 mt-0"
                    style="width:90px"
                    v-model="computedDateFormatted"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  no-title
                  v-model="dialogItem.item.date"
                  scrollable
                  color="primary"
                  locale="fr-fr"
                  first-day-of-week="1"
                >
                  <v-spacer></v-spacer>
                  <v-btn class="text-none" outline round @click="modal = false">Annuler</v-btn>
                  <v-btn
                    class="text-none primary"
                    round
                    flat
                    @click="$refs.dialog.save(dialogItem.item.date)"
                  >Ok</v-btn>
                </v-date-picker>
              </v-dialog>

              <div style="text-align:center; width:100%;">
                <v-btn
                  outline
                  round
                  class="text-none"
                  @click="deleteItem({category: dialogItem.category, item:dialogItem.item})"
                  :loading="loading"
                >
                  <v-icon>delete_outline</v-icon>
                </v-btn>
                <v-btn
                  class="text-none primary"
                  round
                  flat
                  @click="updateItem({category: dialogItem.category, item:dialogItem.item})"
                  :loading="loading"
                >Sauvegarder</v-btn>
              </div>
            </div>
            <div v-else style="text-align:left">
              <div v-if="dialogItem.item.title" class="title-item">{{dialogItem.item.title}}</div>
              <div
                v-if="dialogItem.item.description"
                class="description-item"
              >{{dialogItem.item.description}}</div>
              <div
                v-if="dialogItem.item.title || dialogItem.item.description"
                class="mt-1" style="font-size:12px"
              >{{computedDateFormatted}}</div>
            </div>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      modal: false,
      ratio: 1
    };
  },
  // updated: function() {
  //   this.$nextTick(function() {
  //     var img = new Image();
  //     let self = this
  //     img.onload = function() {
  //       self.ratio = this.width/this.height
  //     };
  //     img.src = this.dialogItem.item.imageUrl;
  //   });
  // },
  methods: {
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    modifyBackground(newBackground) {
      this.dialogItem.item.background = newBackground;
            this.$store.commit("setLoading", true);
      this.$store.commit("setLoading", false);
    },
    rotate() {
      this.ratio = 1 / this.ratio;
      this.dialogItem.item.rotate ? null : (this.dialogItem.item.rotate = 0);
      this.dialogItem.item.rotate < 270
        ? (this.dialogItem.item.rotate = this.dialogItem.item.rotate + 90)
        : (this.dialogItem.item.rotate = 0);
      this.$store.commit("setLoading", true);
      this.$store.commit("setLoading", false);
    },
    deleteItem(data) {
      this.$store.dispatch("deleteItem", data);
    },
    updateItem(data) {
      let updatedItem = {
        category: data.category,
        item: Object.assign(data.item, {
          background: this.dialogItem.item.background || null,
          date: this.dialogItem.item.date,
          rotate: this.dialogItem.item.rotate || 0,
          title: this.dialogItem.item.title || "",
          description: this.dialogItem.item.description || ""
        })
      };
      this.$store.dispatch("updateItem", updatedItem);
    }
  },
  computed: {
    computedDateFormatted() {
      return this.formatDate(this.dialogItem.item.date);
    },
    // imageRation() {
    //   // var img = document.getElementById("image-size");
    //   // //or however you get a handle to the IMG
    //   // var width = img.clientWidth;
    //   // var height = img.clientHeight;
    //   console.log("okiooo")
    //   return document.getElementById("image-size")
    // },
    // dateItem: {
    //   get: function() {
    //     return this.dialogItem.item.date || this.$store.state.dateItem;
    //   },
    //   set: function(newValue) {
    //     this.$store.commit("setDateItem", newValue);
    //   }
    // },
    ...mapState(["loading", "user"]),
    dialogItem: {
      get: function() {
        return this.$store.state.dialogItem;
      },
      set: function(newValue) {
        this.$store.commit("setDialogItem", newValue);
      }
    }
  }
};
</script>

<style scoped>
.border-radius-right {
  border-radius: 0px 4px 4px 0px !important;
}
.border-radius-bottom {
  border-radius: 0px 0px 4px 4px !important;
}
.title-item {
  font-size: 17px;
  padding: 20px 0px 0px;
}
.shadow {
  text-shadow: 0px 2px 5px #000000;
}
.slow-rotation {
  transition: all 0.5s;
}

</style>
